<h2 mat-dialog-title>Finalise Tow</h2>

<mat-dialog-content>
  <mat-horizontal-stepper [linear]="true" #stepper>
    <mat-step [stepControl]="checksValid">
      <ng-template matStepLabel>Tow sample checks</ng-template>
      @if (checks | async; as checks) {
        @if (!checksValid) {
          <p style="color: indianred">Cannot finalise due to errors - see below.</p>
        }
        @for (sample of checks; track $index) {
          <h3>Sample {{ sample.sampleNo }}</h3>
          <app-finalisation-report [report]="sample.checks" />
        }
      } @else {
        <mat-spinner />
      }
    </mat-step>
    <mat-step [stepControl]="checksValid">
      <ng-template matStepLabel>Tow Details</ng-template>
      <div class="tow-details-grid">
        <mat-form-field class="tow-details-readonly-field">
          <mat-label>Ship Name</mat-label>
          <input matInput readonly [value]="shipName" />
        </mat-form-field>

        <mat-form-field class="tow-details-readonly-field">
          <mat-label>Tow Month & Year</mat-label>
          <input matInput readonly [value]="towMonthYear" />
        </mat-form-field>

        <mat-form-field class="tow-details-readonly-field">
          <mat-label>CPR ID</mat-label>
          <input matInput readonly [value]="cprId" />
        </mat-form-field>

        <mat-form-field class="tow-details-readonly-field">
          <mat-label>CPR Internal ID</mat-label>
          <input matInput readonly [value]="cprInternalId" />
        </mat-form-field>

        <mat-form-field class="tow-details-readonly-field">
          <mat-label>Validity</mat-label>
          <input matInput readonly [value]="validity" />
        </mat-form-field>
      </div>
    </mat-step>
    <mat-step [stepControl]="checksValid">
      <ng-template matStepLabel>Tow log review</ng-template>
      @if (tow) {
        <app-tow-log-table [tow]="tow" />
      }
    </mat-step>
    <mat-step [stepControl]="checksValid">
      <ng-template matStepLabel>Sample Overview</ng-template>

      <div class="sample-stats-row">
        <div><strong>Total Number of Samples:</strong> {{ totalSampleCount }}</div>
        <div><strong>Number of samples analysed:</strong> {{ analysedSampleCount }}</div>
      </div>

      @if (samplesLoading) {
        <mat-spinner />
      } @else {
        <div class="sample-table-wrap">
          <table mat-table [dataSource]="samples">
            <ng-container matColumnDef="sampleNo">
              <th mat-header-cell *matHeaderCellDef>Sample no.</th>
              <td mat-cell *matCellDef="let item">{{ item.sampleNo }}</td>
            </ng-container>

            <ng-container matColumnDef="userId">
              <th mat-header-cell *matHeaderCellDef>Analyst</th>
              <td mat-cell *matCellDef="let item">
                <app-user-avatar [userId]="item.userId" />
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let item">
                <cpr-sample-status [sample]="item" />
              </td>
            </ng-container>

            <ng-container matColumnDef="chlorophyllIndex">
              <th mat-header-cell *matHeaderCellDef>PCI Colour</th>
              <td mat-cell *matCellDef="let item">
                <app-pci-colour [value]="item.chlorophyllIndex" />
              </td>
            </ng-container>

            <ng-container matColumnDef="sampleLatitude">
              <th mat-header-cell *matHeaderCellDef>Latitude</th>
              <td mat-cell *matCellDef="let item">{{ item.coordinates?.[1] | coord: 'lat' }}</td>
            </ng-container>

            <ng-container matColumnDef="sampleLongitude">
              <th mat-header-cell *matHeaderCellDef>Longitude</th>
              <td mat-cell *matCellDef="let item">{{ item.coordinates?.[0] | coord: 'lng' }}</td>
            </ng-container>

            <ng-container matColumnDef="sampleMidpointDate">
              <th mat-header-cell *matHeaderCellDef>UTC Midpoint Date</th>
              <td mat-cell *matCellDef="let item">
                {{ item.sampleMidpointDate | date: 'medium' : 'UTC' }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="sampleHeadings"></tr>
            <tr mat-row *matRowDef="let row; columns: sampleHeadings"></tr>

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="sampleHeadings.length">
                <span>No matching data</span>
              </td>
            </tr>
          </table>
        </div>
      }
    </mat-step>
    <mat-step [stepControl]="checksValid">
      <ng-template matStepLabel>Confirm</ng-template>
      Click the finalise button below to finalise the tow.
    </mat-step>
  </mat-horizontal-stepper>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-dialog-close mat-button style="margin-right: auto">Cancel</button>
  <button mat-stroked-button (click)="previousStep()" [disabled]="stepper.selectedIndex == 0">
    Previous
  </button>
  <button
    *ngIf="stepper.selectedIndex !== stepper.steps.length - 1"
    mat-flat-button
    [disabled]="!checksValid || finalising"
    (click)="nextStep()"
  >
    Next
  </button>
  <button
    *ngIf="stepper.selectedIndex == stepper.steps.length - 1"
    mat-flat-button
    [disabled]="!checksValid || finalising"
    (click)="finalise()"
  >
    Finalise
  </button>
</mat-dialog-actions>
